import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const InfoBanner = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px 20px;
  background-color: #ffba01;
  position: relative;

  @media screen and (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
  }
`

const InfoBannerText = styled.p`
  max-width: 800px;
  margin: 0;
  color: #000000;
  font-family: "Roboto", "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 500;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #333333;
  cursor: pointer;
  padding: 0;
  margin-left: 15px;

  @media screen and (max-width: 640px) {
    align-self: flex-end;
  }
`

export const Banner = ({ children }) => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const dismissed = sessionStorage.getItem('bannerDismissed')
    if (dismissed === 'true') {
      setVisible(false)
    }
  }, [])

  const handleClose = () => {
    sessionStorage.setItem('bannerDismissed', 'true')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <InfoBanner>
      <InfoBannerText>{children}</InfoBannerText>
      <CloseButton onClick={handleClose} aria-label="Stäng bannern"><span class="pi pi-times"></span></CloseButton>
    </InfoBanner>
  )
}
